import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  useHistory,
  useRouteMatch
} from "react-router";
import { IndexView, ShowView, withBreadCrumbs } from "lego-gui-lib/lib";
import i18next from "i18next";
import { webUserContext, WebUserSchema } from "./schema";
import { useTranslation } from "react-i18next";
import { NestedView } from "../../common/nestedViewComponent";
import { WebUserAccessIndex, WebUserAccessShow } from "./webUserAccess/views";
import { ParentRoute } from "../../core/model/parent";

export const WebUsers = {
  url: "/webUsers",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:webUser:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <ParentRoute path={baseUrl + "/:id"} dataSourceName={"webUser"} />
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route
            path={baseUrl + "/:id/webAccess/:webAccessId"}
            component={WebUserAccessShow}
          />
          <Redirect from={baseUrl + "/:id/webAccess"} to={baseUrl + "/:id"} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};
export const Index = observer(({ ...rest }: any) => {
  const webUser = useContext(webUserContext);
  const i18n = useTranslation();
  const title = i18n.t("hns:webUser:domain", { count: 2 });
  return (
    <IndexView
      dataSource={webUser.listDataSource}
      {...rest}
      title={title}
      titleButtons={() => <></>}
      toolbarButtons={{ delete: false, export: false }}
      rowButtons={{ edit: true, delete: false, copy: false, export: false }}
      columns={WebUserSchema}
    />
  );
});

export const Show = observer((rest: any) => {
  const webUser = useContext(webUserContext);
  const i18n = useTranslation();
  const title = i18n.t("common:edit", { domain: "hns:webUser:domain" });
  const match = useRouteMatch();
  const history = useHistory();

  return withBreadCrumbs(
    { to: match.url + "/edit", children: title },
    <NestedView
      showView={
        <ShowView
          dataSource={webUser.oneDataSource}
          title={title}
          fields={WebUserSchema}
          id={match.params}
          onlyView={true}
          preloadData={false}
          goBack={() => history.goBack()}
        />
      }
      indexView={<WebUserAccessIndex match={match} {...rest} />}
    />
  );
});
